// extracted by mini-css-extract-plugin
export default {"container":"MenuSocialLinks-module--container--Vy9I5","title":"MenuSocialLinks-module--title--rq8FA","icon":"MenuSocialLinks-module--icon--f2d99"};